export default __webpack_public_path__ + "static/media/solution-en-ligne.b01fdcd2.jpg";